import { FC } from 'react';
import { MaybeLoanID } from 'src/common/types';
import { ServerSideModuleData } from '../../GetServerSideProps/utils/getServerSideModuleData';
import { LocalStorageUIStateStore } from './utils/LocalStorageUIStateStore';
import { useWelcomeBannerState } from './useWelcomeBannerState';
import { WelcomeBanner } from './WelcomeBanner';

const Store = new LocalStorageUIStateStore();
export type WiredWelcomeBannerProps = {
    loanID: MaybeLoanID;
    serverFetchedData: Pick<ServerSideModuleData, 'WelcomeBanner'>;
};
export const WiredWelcomeBanner: FC<WiredWelcomeBannerProps> = ({ loanID, serverFetchedData }) => {
    const { onClose, headerWelcome, shouldDisplay } = useWelcomeBannerState({ Store, loanID, serverFetchedData });

    return (
        <WelcomeBanner shouldDisplay={shouldDisplay} onClose={onClose}>
            {headerWelcome}
        </WelcomeBanner>
    );
};
